import "./AnalyticsChoose.css";

export default function AnalyticsChoose() {
  return (
    <div id="analytics-choose" className="outsourcemainclass">
      <div className="overlaynew"></div>
      <div className="left">
        <div className="overlay"></div>
        <div className="content">
          <h2 className="heading">Why Choose BastionEx for Configuration Management?</h2>
          <p className="subheading">
            A structured and reliable approach to managing infrastructure
            efficiently, ensuring consistency, stability, and long-term
            operational success.
          </p>
        </div>
      </div>
      <div className="right">
        <div className="overlay"></div>
        <div className="content">
          <div className="item">
            <h3>Industry Competency</h3>
            <span>
             Our experts have a deep understanding of diverse industries and business processes to tailor data & analytics services to business needs.
            </span>
          </div>
          <div className="item">
            <h3>
              Diverse Clientele
            </h3>
            <span>
             We have rich experience in supporting clients of all sizes, from funded startups and ISVs to SMBs and enterprise-level organizations.
            </span>
          </div>
          <div className="item">
            <h3>
             Global Partnerships
            </h3>
            <span>
             We have built a strong partnership with global clients spanning diverse industries. Many of our clients have been associated with us for over 6 years.
            </span>
          </div>
          <div className="item">
            <h3>Cost-Efficient Support</h3>
            <span>
              As an offshore data & analytics company, we offer custom support services such as consulting, ad-hoc support, and SLA-based services as per your time zone.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
